import script from "./NewAchievementMotion.vue?vue&type=script&setup=true&lang=js"
export * from "./NewAchievementMotion.vue?vue&type=script&setup=true&lang=js"

import "./NewAchievementMotion.vue?vue&type=style&index=0&id=db833dc8&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src3857685418/src/wfyt-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db833dc8"]])

export default __exports__